import api from './api';

export const getTasks = (spaceId) => api.get(`/spaces/${spaceId}/tasks`);
export const getMyTasks = (params = {}) => api.get('/me/tasks', { params });
export const createTask = (spaceId, data) => api.post(`/spaces/${spaceId}/tasks`, data);
export const updateTask = (spaceId, taskId, data) => api.patch(`/spaces/${spaceId}/tasks/${taskId}`, data);
export const deleteTask = (spaceId, taskId) => api.delete(`/spaces/${spaceId}/tasks/${taskId}`);

// Subtasks
export const addSubtask = (spaceId, taskId, data) =>
  api.post(`/spaces/${spaceId}/tasks/${taskId}/subtasks`, data);
export const updateSubtask = (spaceId, taskId, subtaskId, data) =>
  api.patch(`/spaces/${spaceId}/tasks/${taskId}/subtasks/${subtaskId}`, data);
export const deleteSubtask = (spaceId, taskId, subtaskId) =>
  api.delete(`/spaces/${spaceId}/tasks/${taskId}/subtasks/${subtaskId}`);

// Attachments
export const addTaskAttachment = (spaceId, taskId, data) =>
  api.post(`/spaces/${spaceId}/tasks/${taskId}/attachments`, data);
export const removeTaskAttachment = (spaceId, taskId, fileRefId) =>
  api.delete(`/spaces/${spaceId}/tasks/${taskId}/attachments/${fileRefId}`);

